module.exports = __webpack_public_path__ + "media/video-background-3.d0e74d05.mp4";